export default "__VITE_ASSET__7gzAV5Ev__"